import { formatPercent } from "../../../../../components/utils/formatPercent";
import { formatUsd } from "../../../../../components/utils/formatUsdAmount";
import { formatTokenAmount } from "../../../../../components/utils/formatTokenAmount";
export function formatFee(percentageFee, fixedFeeUsd) {
    const parts = [];
    const pct = formatPercent(percentageFee);
    if (pct)
        parts.push(pct);
    if (fixedFeeUsd > 0)
        parts.push(formatUsd(fixedFeeUsd));
    return parts.join(' + ') || 'Free';
}
export function formatTierRange(tier, isFirst, isLast, asset) {
    const min = formatTokenAmount(tier.min_amount);
    const max = formatTokenAmount(tier.max_amount);
    if (isFirst)
        return `Up to ${max} ${asset}`;
    if (isLast)
        return `Over ${min} ${asset}`;
    return `${min} – ${max} ${asset}`;
}
